import styled from "styled-components";
import { SPACING } from "../../../../utils/constants";

export const FooterNote = styled.p`
  margin: 0;
  padding: 0 ${SPACING.xs}px;
  font-size: var(--text-sm);
  color: var(--color-text-secondary);
`;
